import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=63036d34&"
import script from "./Users.ts?vue&type=script&lang=ts&"
export * from "./Users.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports